/**
 * O Chat a um clique, de qualquer tela (pedido do Igor, 2026-10-28): antes
 * ele morava só no menu lateral, dentro de "Visão Geral", e ninguém achava.
 *
 * O botão fica no cabeçalho, ao lado do sino, com o número de CONVERSAS com
 * mensagem não lida (o mesmo do menu). Quem já está no Chat vê o botão
 * marcado. Os números chegam do cabeçalho (`useNotificacoesAgregadas`) — o
 * botão não faz pedido próprio.
 *
 * Sempre abre em tela cheia (pedido do Igor, 2026-11-03): com o chat na
 * lateral, ele sai de lá e abre a página na mesma conversa.
 */

import { FiMessageCircle } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

import { chatDaLateral, enderecoDaTelaCheia, fecharChatDaLateral } from "../../pages/Chat/lateral";
import { BellBadge, BellButton } from "../NotificationBell/styles";

const Botao = styled(BellButton)`
  ${({ $ativo, theme }) =>
    $ativo &&
    `
    color: ${theme.accent};
    border-color: ${theme.accent};
  `}
`;

function rotulo(conversas, mencoes) {
  if (mencoes > 0) return `Chat — ${mencoes} menção(ões) a você`;
  if (conversas === 1) return "Chat — 1 conversa com mensagem nova";
  if (conversas > 1) return `Chat — ${conversas} conversas com mensagem nova`;
  return "Abrir o Chat";
}

export default function BotaoDoChat({ conversasNaoLidas = 0, mencoes = 0 }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const noChat = pathname === "/chat" || pathname.startsWith("/chat/");
  const numero = conversasNaoLidas;
  const descricao = rotulo(conversasNaoLidas, mencoes);
  return (
    <Botao
      type="button"
      $ativo={noChat}
      aria-current={noChat ? "page" : undefined}
      onClick={() => {
        const { aberta, conversaId } = chatDaLateral();
        fecharChatDaLateral();
        navigate(aberta ? enderecoDaTelaCheia(conversaId) : "/chat");
      }}
      aria-label={descricao}
      title={descricao}
    >
      <FiMessageCircle size={16} />
      {numero > 0 && <BellBadge>{numero > 99 ? "99+" : numero}</BellBadge>}
    </Botao>
  );
}
